import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MedicamentosService {
  private medicamentosApiUrl = `${environment.apiUrl}/medicamentos`;
  constructor(private http: HttpClient) {}

  crearMedicamento(medicamento: any): Observable<any> {
    return this.http.post<any>(this.medicamentosApiUrl, medicamento);
  }

  actualizarMedicamento(idMedicamento: string, medicamento: any): Observable<any> {
    return this.http.patch<any>(`${this.medicamentosApiUrl}/${idMedicamento}`, medicamento);
  }

  eliminarMedicamento(idMedicamento: string): Observable<any> {
    return this.http.delete<any>(`${this.medicamentosApiUrl}/${idMedicamento}`);
  }
}
